export default {
  /**
   * Tính giá
   */
  CalculatePrice: 1,

  /**
   * Thông báo nâng cấp
   */
  AnnounceUpgrade: 2,

  /**
   * Đánh lại số chứng từ
   */
  ReOrderRefNo: 3,

  /**
   * Ghi sổ bỏ ghi theo lô
   */
  PostBath: 4,

  /**
   * Khóa sổ
   */
  CloseBook: 5,

  /**
   * Thông báo sắp hết hạn license
   */
  WarningExpired: 8,

  /**
   * Bảo trì
   */
  ReBuild: 9,

  /**
   * bắt đầu chuyển đổi dữ liệu desktop - online
   */
  StartConvert: 15,
  /**
   * Chuyển đổi dữ liệu xong
   */
  EndConvert: 16,
  /**
   * Chuyển đổi bị lỗi
   */
  ConvertError: 17,
  /**
   * Lỗi tạo dữ liệu
   */
  ErrorCreateData: 18,
  /**
   * Hoàn thành tạo dữ liệu
   */
  EndCreateData: 19,
  /**
   * Hoàn thành sao lưu
   */
  Backup: 20,
  /**
   * Hoàn thành phục hồi
   */
  Restore: 21,

  /**
   * Hệ thống
   */
  System: 101,

  /**
   * Khuyến mại
   */
  Promotion: 102,

  // Bắt đầu sao chép dữ liệu
  CopyDataStart: 22,
  // Hoàn thành sao chép dữ liệu
  CopyDataComplete: 23,
  // Sao chép dữ liệu lỗi
  CopyDataError: 24,
  // Chia sẻ dữ liệu
  ShareData: 25,

  /**
   * Chuyển đổi chế độ kế toán lỗi
   */
  ConvertAccountingSystemError: 27,

  /**
   * Chuyển đổi chế độ kế toán thành công
   */
  ConvertAccountingSystemSuccess: 28,
  /**
   * Kiểm tra số dư tài khoản từ thông tư cũ
   */
  CheckOpeningAccountFromOldCircular: 29,

  /**
   * Hoàn thành Lưu trữ dữ liệu
   */
  Store: 30,
  /**
   * Hoàn thành phục hồi Lưu trữ dữ liệu
   */
  RestoreStored: 31,

  /**
   * Lấy số dư từ năm trước
   */
  GetDataPrevYear: 35,
};
